import { useState } from 'react'
import { supabase } from '@/lib/supabase'
import { toast } from '@/hooks/use-toast'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/translations/tokens';

export function useSocialSignIn() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false)

  async function socialSignIn(provider: 'google' | 'github') {
    setLoading(true)

    const currentUrl = new URL(window.location.href)
    const redirectTo = currentUrl.searchParams.get('redirectTo')
    const targetRedirect = redirectTo
      ? `${window.location.origin}/sign-in?redirectTo=${encodeURIComponent(redirectTo)}`
      : `${window.location.origin}/sign-in`

    const response = await supabase.auth.signInWithOAuth({
      provider,
      options: { redirectTo: targetRedirect },
    })
    setLoading(false)

    if (response.error) {
      toast({
        variant: 'destructive',
        title: t(tokens.ui.toasts.auth.login_error.title),
        description: response.error.message,
      })
    }

    return response.data
  }

  return { socialSignIn, loading }
}
